import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        borderTop: '1px solid rgba(255, 255, 255, 0.05)',
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="body2"
          align="center"
          sx={{
            color: 'rgba(255, 255, 255, 0.7)',
          }}
        >
          © {new Date().getFullYear()} Nuyu Agency. Designed by{' '}
          <Link
            href="https://github.com/snow-blade"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: 'primary.main',
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            @snow-blade
          </Link>
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
